const ISTANBUL_TIME_ZONE = "Europe/Istanbul";

const istanbulDateFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: ISTANBUL_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
});

function parseIsoDate(value: string) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) throw new Error(`INVALID_ISO_DATE:${value}`);
  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3])
  };
}

function isoFromUtcDate(value: Date) {
  return [
    String(value.getUTCFullYear()).padStart(4, "0"),
    String(value.getUTCMonth() + 1).padStart(2, "0"),
    String(value.getUTCDate()).padStart(2, "0")
  ].join("-");
}

export function istanbulToday(value = new Date()) {
  return istanbulDateFormatter.format(value);
}

export function istanbulCalendarDate(value: Date) {
  return istanbulDateFormatter.format(value);
}

export function istanbulHour(value = new Date()) {
  const hour = new Intl.DateTimeFormat("en-GB", {
    timeZone: ISTANBUL_TIME_ZONE,
    hour: "2-digit",
    hourCycle: "h23"
  }).format(value);
  return Number(hour);
}

export function isoDateAtNoon(value: string) {
  return new Date(`${value}T12:00:00+03:00`);
}

export function addIsoDays(value: string, days: number) {
  const { year, month, day } = parseIsoDate(value);
  return isoFromUtcDate(new Date(Date.UTC(year, month - 1, day + days, 12)));
}

export function shiftIsoMonth(value: string, months: number) {
  const { year, month, day } = parseIsoDate(value);
  const targetIndex = year * 12 + month - 1 + months;
  const targetYear = Math.floor(targetIndex / 12);
  const targetMonthIndex = ((targetIndex % 12) + 12) % 12;
  const lastDay = new Date(Date.UTC(targetYear, targetMonthIndex + 1, 0)).getUTCDate();
  return [
    String(targetYear).padStart(4, "0"),
    String(targetMonthIndex + 1).padStart(2, "0"),
    String(Math.min(day, lastDay)).padStart(2, "0")
  ].join("-");
}

export function monthBounds(monthKey: string) {
  const match = /^(\d{4})-(\d{2})$/.exec(monthKey);
  if (!match) throw new Error(`INVALID_MONTH_KEY:${monthKey}`);
  const year = Number(match[1]);
  const month = Number(match[2]);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return {
    start: `${monthKey}-01`,
    end: `${monthKey}-${String(lastDay).padStart(2, "0")}`
  };
}

export function appointmentRangeAroundToday(value = new Date()) {
  const today = istanbulToday(value);
  return {
    from: shiftIsoMonth(today, -2),
    to: shiftIsoMonth(today, 1)
  };
}
